import React from 'react'
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import { Typography, Box, useTheme } from '@mui/material'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'

const styles = (theme: any) => ({
  container: {
    width: '100%',
    height: 400,
    [theme.breakpoints.down('sm')]: {
      height: 300,
    },
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  legendUi: {
    listStyle: 'none',
    padding: 0,
    textAlign: 'center',
  },
  legendLi: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 20,
    marginBottom: 8,
  },
  legendSpan: {
    display: 'inline-block',
    width: 10,
    height: 10,
    marginRight: 8,
  },
})

const ConsumptionChart: React.FC<any> = ({ data, total, title }) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  // const renderLabel = (entry: any) => {
  //   const percentage = total && total > 0 ? (entry?.value / total) * 100 : 0

  //   if (percentage < 2) return null

  //   return `${entry?.value}`
  // }

  const renderLegend = (props: any) => {
    const { payload } = props

    return (
      <ul className={classes?.legendUi}>
        {payload?.map((entry: any, index: number) => {
          const matchedData = data?.find(
            (item: any) => item?.name === entry?.value
          )
          const value = matchedData?.value || 0
          const percentage =
            total && total > 0 ? ((value / total) * 100).toFixed(0) : '0'

          return (
            <li key={`item-${index}`} className={classes?.legendLi}>
              <span
                style={{
                  backgroundColor: entry?.color,
                }}
                className={classes?.legendSpan}
              />
              <span>
                {entry?.value} - ₹{value} ({percentage}%)
              </span>
            </li>
          )
        })}
      </ul>
    )
  }

  return (
    <Box className={classes.container}>
      <Typography variant='h6' className={classes.title}>
        {title}
      </Typography>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey='value'
            nameKey='name'
            // label={renderLabel}
            outerRadius='80%'
          >
            {data?.map((entry: any, index: number) => (
              <Cell key={`cell-${index}`} fill={entry?.color} />
            ))}
          </Pie>
          <Tooltip />
          <Legend
            layout='horizontal'
            verticalAlign='bottom'
            align='center'
            content={renderLegend}
          />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  )
}

export default ConsumptionChart

// import React from 'react'
// import {
//   PieChart,
//   Pie,
//   Cell,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from 'recharts'
// import { Typography, Box, useTheme } from '@mui/material'
// import useCustomStyles from '../../utils/hooks/CustomStylesHook'

// const styles = (theme: any) => ({
//   container: {
//     width: '100%',
//     height: 400,
//     [theme.breakpoints.down('sm')]: {
//       height: 300,
//     },
//   },
//   title: {
//     fontWeight: 'bold',
//     textAlign: 'center',
//     marginBottom: theme.spacing(2),
//   },
// })

// const renderCustomizedLabel = (props: any) => {
//   const RADIAN = Math.PI / 180
//   const { cx, cy, midAngle, outerRadius, percent, value } = props

//   // Skip labels with < 2% to avoid clutter
//   if (percent < 0.02) return null

//   const radius = outerRadius + 20
//   const x = cx + radius * Math.cos(-midAngle * RADIAN)
//   const y = cy + radius * Math.sin(-midAngle * RADIAN)

//   return (
//     <text
//       x={x}
//       y={y}
//       fill='black'
//       textAnchor={x > cx ? 'start' : 'end'}
//       dominantBaseline='central'
//       fontSize={12}
//     >
//       {`${value}, ${(percent * 100).toFixed(0)}%`}
//     </text>
//   )
// }

// const ConsumptionChart = ({ data }: any) => {
//   const theme = useTheme()
//   const classes = useCustomStyles(styles, theme)

//   return (
//     <Box className={classes.container}>
//       <Typography variant='h6' className={classes.title}>
//         Ayuvu Bharosa Consumption
//       </Typography>
//       <ResponsiveContainer>
//         <PieChart>
//           <Pie
//             data={data}
//             dataKey='value'
//             nameKey='name'
//             outerRadius='80%'
//             labelLine={false}
//             label={renderCustomizedLabel}
//           >
//             {data?.map((entry: any, index: number) => (
//               <Cell key={`cell-${index}`} fill={entry?.color} />
//             ))}
//           </Pie>
//           <Tooltip />
//           <Legend layout='horizontal' verticalAlign='bottom' align='center' />
//         </PieChart>
//       </ResponsiveContainer>
//     </Box>
//   )
// }

// export default ConsumptionChart
